import React from 'react';
import classNames from 'classnames';

import './card.scss';

import type { FlexProps } from '../Layout/Flex';
import Flex from '../Layout/Flex';

export type CardProps = FlexProps & {
  appearance?: 'default' | 'primary';
  /** Makes the entire Card clickable and introduces a hover color. */
  onClick?: React.DOMAttributes<HTMLDivElement>['onClick'];
  noShadow?: boolean;
  disabled?: boolean;
  selected?: boolean;
};

const Card = (props: CardProps): JSX.Element => {
  const {
    className,
    onClick,
    noShadow,
    appearance = 'default',
    disabled,
    children,
    padding = 'sm',
    selected,
    ...flexProps
  } = props;

  const disabledOverlay = disabled ? <div className="dragonfruit-card--disabled-overlay" /> : null;

  return (
    <Flex
      direction="column"
      padding={padding}
      {...flexProps}
      className={classNames('dragonfruit-card', className, {
        'dragonfruit-card--clickable': Boolean(onClick) && !disabled,
        'dragonfruit-card--noShadow': Boolean(noShadow),
        'dragonfruit-card--primary': appearance === 'primary',
        'dragonfruit-card--selected': selected,
      })}
      aria-label="card"
      onClick={disabled ? undefined : onClick}
    >
      {disabledOverlay}
      {children}
    </Flex>
  );
};

export default Card;
